import type { IssueLabel } from '@overlayqa/shared';
import { IssueLabelsEditor, type LabelRequest } from '@overlayqa/shared/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../../lib/auth';
import { fetchApi } from '../../lib/api/client';
import { ISSUE_MUTATION_INVALIDATE_KEYS } from '../../hooks/issueMutationInvalidation';
import { SelectDropdown } from '../shared/SelectDropdown';

export function IssueLabelsField({ issueId, labels, readOnly, variant }: { issueId: string; labels?: IssueLabel[]; readOnly?: boolean; variant?: 'toggle' | 'field' | 'inline' }) {
  const { getToken } = useAuth();
  const cache = useQueryClient();
  const request: LabelRequest = async (path, options) => fetchApi(path, { ...options, token: (await getToken()) ?? undefined });
  return <IssueLabelsEditor key={issueId} issueId={issueId} labels={labels} request={request} readOnly={readOnly}
    buttonClassName="btn btn-secondary btn-sm" inputClassName="input"
    variant={variant} titleClassName="block text-xs font-medium text-gray-500 mb-1"
    renderPicker={props => <SelectDropdown {...props} size={variant === 'inline' ? 'toolbar' : 'default'} />}
    onChanged={() => { for (const queryKey of ISSUE_MUTATION_INVALIDATE_KEYS) void cache.invalidateQueries({ queryKey }); void cache.invalidateQueries({ queryKey: ['tickets'] }); }} />;
}
